import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { isUserAuthenticated, usePageTitle } from "../helpers";
import logo from "@images/logo.png";
import AddressBar from "./Layout/AddressBar";
import { getPageContent } from "@/services";
import _ from "lodash";

const Pages = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const params = useParams();
  // const params = useParams();
  const navigate = useNavigate();
  const slug = params.slug;

  usePageTitle(_.capitalize(slug));

  useEffect(() => {
    if (slug) {
      dispatch(getPageContent(slug))
        .unwrap()
        .then((res) => {
          if (res?.success) setData(res?.data);
          else navigate("/", { replace: true });
        });
    }
    // else navigate('/', { replace: true })
  }, [slug, dispatch, navigate]);

  return (
    <div className="center flex-column bg-light">
      {!isUserAuthenticated() ? (
        <div className="d-flex justify-content-start col-12 Bg-fff">
          <div className="p-3">
            <Link to={"/"}>
              <img alt="logo" src={logo} className="w-50" />
            </Link>
          </div>
        </div>
      ) : (
        <div className="w-100">
          <AddressBar page={[{ name: data?.name || "" }]} />
        </div>
      )}

      <div className="center">
        {data?.content ? (
          <>
            <style>{`
              .cms-page-content img { max-width: 100% !important; height: auto !important; }
              .cms-page-content iframe { max-width: 100% !important; width: 100% !important; height: auto !important; aspect-ratio: 16/9; }
              .cms-page-content table { max-width: 100% !important; width: 100% !important; display: block; overflow-x: auto; }
              .cms-page-content figure { max-width: 100% !important; margin: 0; }
            `}</style>
            <div
              dangerouslySetInnerHTML={{ __html: data?.content }}
              className="pb-5 Bg-fff p-2 px-md-4 px-3 cms-page-content"
            />
          </>
        ) : (
          <div className="center" style={{ height: "75vh" }}>
            <Spinner
              animation="border"
              size="lg"
              style={{ height: "55px", width: "55px" }}
            />
          </div>
        )}

      </div>
    </div>
  );
};

export default Pages;
